<div class="title p-2">
	<div class="row">
		<div class="col d-flex justify-content-between align-items-center">
			<h1 class="mx-2 mt-3">
				<span>Info cerere
					{{ cerere?.indoc_number ? cerere?.indoc_number : "N/A" }} /
					{{ cerere?.created_date }}
				</span>
				<span class="text-secondary m-2">#{{ cerere?.id_cerere }}</span>
				<button type="button" class="btn btn-small btn-primary" (click)="getRequestInfo()">
					<i class="fa-solid fa-arrows-rotate"></i>
					<span class="ms-2"> Reîncarcă informații</span>
				</button>
			</h1>
			<button *ngIf="hasDraft" type="button" class="btn btn-primary nav-btn mx-2" (click)="generareDraftBtn()">
				<span>Generare Print Cerere</span>
			</button>
		</div>
		<div class="col d-flex justify-content-end">
			<button type="button" class="action-btn" (click)="closeDialog()">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
</div>
<div class="row p-3 responsive-content">
	<div class="col-8">
		<mat-card>
			<app-subsemnat [cerere]="cerere"></app-subsemnat>

			<div class="g-0">
				<app-informatii-aditionale *ngIf="cerere" [cerere]="cerere"
					(infoUpdated)="getRequestInfo()"></app-informatii-aditionale>
			</div>

			<div class="g-0">
				<div class="col">
					<div class="box-wrapper box-documents">
						<div class="box-content-header">
							<div class="row p-1">
								<div class="col">
									<mat-card-title>
										<i class="fa-solid fa-folder-tree"></i>
										<span>Documente</span>
									</mat-card-title>
								</div>
							</div>
						</div>
						<div class="box-content-body">
							<!-- <p *ngIf="cerere?.documente && !isObjectEmpty(cerere?.documente)"> Lipsa documente</p> -->
							<div class="p-3" *ngFor="let docTypeKey of getDocumentTypeKeys()">
								<button type="button" class="btn btn-light upload-btn">
									<span class="upload__text">
										<i class="fa-solid fa-layer-group"></i> &nbsp;
										{{ cerere?.documente?.[docTypeKey]?.name }}
									</span>
								</button>
								<div class="p-2">
									<mat-divider></mat-divider>
								</div>
								<div class="p-3" *ngFor="let docKey of getDocumentKeys(docTypeKey)">
									<mat-card-subtitle>{{ cerere?.documente?.[docTypeKey]?.documente?.[docKey]?.name }}
									</mat-card-subtitle>
									<div class="p-2">
										<mat-divider></mat-divider>
									</div>
									<div
										class="docs d-flex flex-row justify-content-start align-items-center flex-wrap">
										<button type="button" class="btn btn-light upload-btn m-2"
											*ngFor="let file of cerere?.documente?.[docTypeKey]?.documente?.[docKey]?.files"
											(click)="downloadDocument(file)">
											<span class="upload__text">
												<img src="assets/icons/icon-download-blue.svg" alt="Descarcă" />
												&nbsp;{{ file.name }}
											</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="g-0">
				<div class="col">
					<div class="box-wrapper box-mesagerie">
						<div class="box-content-header">
							<div class="row p-1">
								<div class="col">
									<mat-card-title>
										<i class="fa-solid fa-book"></i>
										<span>Documente generabile</span>
									</mat-card-title>
								</div>
							</div>
						</div>
						<div class="box-content-body" *ngIf="
                cerere?.validated_date !== null || cerere?.cancel_date !== null
              ">
							<div class="row" *ngIf="cerere?.registratura?.finalize == 0">
								<div class="col">
									<p class="text-center">
										Alegeți tipul documentului ce doriți să îl generați
									</p>
								</div>
							</div>
							<div class="row" *ngIf="cerere?.registratura?.finalize == 0">
								<div class="col d-flex flex-column align-items-center">
									<button *ngIf="
											permissionsService.hasPermission(
												'urbanism-module.solicitari.view.generare-document-oficial'
											)
											" [class.disabled-button]="isDocumentOficialDisabled" type="button"
										class="btn btn-sm d-flex flex-column align-items-center"
										(click)="generateDocOfficial()">
										<img src="assets/icons/doc-generabil-icon.svg" alt="" />
										<strong>Generare document oficial</strong>
									</button>
								</div>
								<div class="col d-flex flex-column align-items-center">
									<button *ngIf="
											permissionsService.hasPermission(
												'urbanism-module.solicitari.view.generare-adresa'
											)
											" type="button" class="btn btn-sm d-flex flex-column align-items-center" (click)="generateDocAdresa()">
										<img src="assets/icons/doc-generabil-icon.svg" alt="" />
										<strong>Generare adresă</strong>
									</button>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<!-- rows/info -->
									<table class="table table-condensed table-wrapper-box">
										<tbody class="border-bottom">
											<ng-container class="border-bottom"
												*ngFor="let row of cerere?.generabile; let i = index">
												<tr class="d-flex justify-content-center align-items-end">
													<td width="20%"
														class="d-flex justify-content-start align-items-start">
														<strong>
															ID: {{ row.id_document }} <br />
															Tip: {{ row.template }}
														</strong>
													</td>
													<td width="80%"
														class="d-flex justify-content-start py-4 flex-buttons-docs">
														<!-- buttons here -->
														<!--
                                                            Story: Actualizare de document generat
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                        -->
														<button *ngIf="
															row.file_signed == null &&
															cerere.id_user_assigned == user.id_user
														" type="button" class="btn btn-sm btn-warning" title="Actualizare Draft"
															(click)="updateDocumentGenerat(row)">
															<i class="fa-regular fa-pen-to-square"></i>
															&nbsp;Actualizează
														</button>

														<!-- exemplar Cetatean (aici putem avea un content - document sau chiar si incarcare de blank/simple pdf initial pentru later signed de la operatori) (buton afisat in contextul in care avem file_signed initial de operator neincarcat, sau doar dupa ce a fost incarcat de catre ultimul semnatar - adaugare in registru sau nu ca si pozitie) -->

														<!-- doc_type === 2 && -->
														<!-- <button *ngIf="row.doc_type == 2 && (
																row.file_signed == null &&
																cerere.id_user_assigned == user.id_user)
															" type="button" class="btn btn-sm" style="background-color: #ff6d00" title="Actualizare Draft"
															(click)="validateDocument(row.id_document, 2)">
															<i class="fa-regular fa-pen-to-square"></i>
															&nbsp;Încărcare exemplar cetățean
														</button> -->
														<!--
                                                            Story: 3 tipuri de download document pe acelasi buton
                                                            Formalities::
                                                                * Daca avem document generat, se va descarca documentul generat/actualizat ca si draft - digital
                                                                * Daca avem documentul semnat de Intocmitor fara sa fie semnat de toti operatorii de pe flux, atunci se va descarca doar documentul semnat si incarcat de Intocmitor
                                                                * Daca avem documentul semnat de toti operatorii de pe flux, atunci se va descarca documentul semnat si incarcat de Intocmitor si semnat de toti operatorii de pe flux
                                                            
                                                            Clause: OR
                                                            Rules to show this button is:
                                                                1. Daca documentul nu este incarcat initial
                                                                2. Daca documentul este incarcat initial si nu este semnat de toti operatorii de pe flux
                                                                3. Daca document oficial este incarcat
                                                        -->
														<button *ngIf="
																row.file_signed == null ||
																(row.file_signed !== null &&
																row.file_signed_final == null &&
																!allFilesSigned(row.signatures)) ||
																row.file_signed_final !== null
															" type="button" class="btn btn-sm btn-primary" style="background-color: #0044cc; border: none;" title="Descarcă"
															(click)="downloadDocumentGenerat(row, 1)">
															<img src="assets/icons/icon-download.svg" alt="Descarcă" />
															&nbsp;Document
														</button>

														<!--  Descarcare document generabil - exemplar Cetatean -->

														<button *ngIf="
																row.doc_type == 2 && (
																row.file_signed == null ||
																(row.file_signed !== null &&
																row.file_signed_final == null &&
																!allFilesSigned(row.signatures)) ||
																row.file_signed_final !== null)
															" type="button" class="btn btn-sm btn-primary" style="background-color: #5476bc; border: none;"
															title="Descarcă (exemplar Cetătean)"
															(click)="downloadDocumentGenerat(row, 2)">
															<img src="assets/icons/icon-download.svg" alt="Descarcă" />
															&nbsp;Document (Exemplar Cetățean)
														</button>

														<!--  Incarcare document oficial semnat in baza descarcarii exemplarului de cetatean - in cazul in care avem mai mult de 1 semnatar -->

														<!--
                                                            Story: Descarcare tabel semnaturi
                                                            Formalities:
                                                                * In urma generarii de document, exista printre semnatari si posibilitatea de a avea pt descarcare un tabel fix cu functiile de tip semnare si sa il incarce pe fluxul lor
                                                        -->
														<button type="button" class="btn btn-sm btn-primary" *ngIf="
																row.file_signed_final == null &&
																!allFilesSigned(row.signatures)
															" style="background-color: #0044cc; border: none;" title="Descarcare Tabel semnaturi" (click)="
																downloadDocumentTableSignatures(row.id_document)
															">
															<img src="assets/icons/icon-download.svg" alt="Descarcă" />
															&nbsp; Descarcă Tabel Semnături
														</button>

														<!--
                                                            Story: Aprobare/Incarcare document semnat de Intocmitor (Prima semnare)
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul oficial final trebuie sa nu fie incarcat!!! Obligatoriu
                                                            Params: 1 => prima validare/aprobare
                                                        -->
														<button *ngIf="
																row.file_signed == null &&
																cerere.id_user_assigned == user.id_user &&
																row.file_signed_final == null
															" type="button" class="btn btn-sm btn-success" title="Aprobare Document"
															(click)="validateDocument(row.id_document, 1, row.doc_type)">
															<i class="fa-solid fa-check"></i> &nbsp; Aprobă
														</button>

														<!--
                                                            Story: Vizualizare istoric document generat (Toate interactiunile de la operatori)
                                                        -->
														<button type="button" class="btn btn-sm btn-info"
															title="Vizualizare Istoric"
															(click)="viewIstoricDocument(row)">
															<i class="fa-solid fa-clock-rotate-left"></i>
														</button>

														<!--
                                                            Story: Stergere document generat
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul nu trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul oficial final trebuie sa nu fie incarcat!!! Obligatoriu
                                                        -->
														<button *ngIf="
															row.file_signed == null &&
															cerere.id_user_assigned == user.id_user &&
															row.file_signed_final == null
														" type="button" class="btn btn-sm btn-danger" title="Stergere document generat"
															(click)="destroyDocumentGenerat(row.id_document)">
															<i class="fa-solid fa-trash-can"></i>
														</button>
														<!--
                                                            Story: Resetare de document incarcat initial de intocmitor 
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul nu trebuie sa fie semnat/aprobat de nimeni de pe flux.. altfel nu  avem voie sa avem afisat acest buton
                                                                * Documentul oficial final trebuie sa nu fie incarcat!!! Obligatoriu
                                                        -->
														<button type="button" class="btn btn-sm btn-danger"
															(click)="resetDocumentIntocmitor(row.id_document)" *ngIf="
																row.shouldReset &&
																row.file_signed !== null &&
																row.file_signed_final == null &&
																row.validare_user_type == 0 &&
																cerere.id_user_assigned == user.id_user
															">
															<i class="fa-solid fa-arrows-rotate"></i>
															&nbsp;Reset
														</button>
														<!--
                                                            Story: Inregistrarea in registru a documentului generat + semnat de toti operatorii de pe flux
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul trebuie sa fie semnat/aprobat de toata lumea de pe flux
                                                                * Documentul oficial final trebuie sa nu fie incarcat!!! Obligatoriu
                                                                * Toti semnatarii de pe document trebuie sa fi finalizat semnarea de document
                                                                * Sa nu aibe numar alocat pe document generat/oficial
                                                                * Sa nu detina un Registru alocat
                                                        -->
														<button *ngIf="
															allFilesSigned(row.signatures) &&
															row.numar == null &&
															row.registru_id == null &&
															cerere.id_user_assigned == user.id_user &&
															row.file_signed_final == null &&
															row.file_signed !== null && row.registru_necesar
														" type="button" class="btn btn-sm btn-primary" style="background-color: #ff6d00; border: none"
															title="Registru" (click)="openRegistruValability(row)">
															<i class="fa-solid fa-book-open mx-1"></i>
															Registru
														</button>
														<!--
                                                            Story: Incarcare de document oficial final
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul trebuie sa fie semnat/aprobat de toata lumea de pe flux
                                                                * Documentul oficial final trebuie sa nu fie incarcat!!! Obligatoriu
                                                                * Si obligatoriu sa aibe numar alocat
                                                            Params: 3 => reprezinta practic afisarea de componenta pentru incarcarea de document oficial + anexe(optional)
                                                        -->
														<button *ngIf="
																allFilesSigned(row.signatures) &&
																(row.numar !== null || row.registru_necesar == false) &&
																row.file_signed_final == null &&
																row.file_signed !== null &&
																cerere.id_user_assigned == user.id_user 
															" type="button" class="btn btn-sm btn-success" title="Incarca Document Oficial"
															(click)="validateDocument(row.id_document, 3, row.doc_type)">
															<img src="assets/icons/upload-icon.svg" alt="Incarca" />
															Incarcă Document Oficial
														</button>

														<!--
                                                            Story: Resetare de document oficial final
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul trebuie sa fie semnat/aprobat de toata lumea de pe flux
                                                                * Documentul oficial final trebuie sa fie incarcat!!! Obligatoriu
                                                                * Si obligatoriu sa aibe numar alocat
                                                                * Si sa nu fie confirmata trimiterea catre cetatean de documente via notificare
                                                        -->
														<button type="button" class="btn btn-sm btn-danger" (click)="
																resetUploadDocumentOfficial(row.id_document)
															" *ngIf="
																row.file_signed_final !== null &&
																row.confirmat == null &&
																cerere.id_user_assigned == user.id_user &&
																(row.numar !== null || row.registru_necesar == false)
															">
															<i class="fa-solid fa-arrows-rotate"></i>
															&nbsp;Reset
														</button>
														<!--
                                                            Story: Trimitere document inainte pe flux catre operatori pentru semnare
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat/aprobat de toata lumea de pe flux
                                                                * Documentul oficial final nu trebuie sa fie incarcat!!! Obligatoriu
                                                                * Documentul semnat de catre intocmitor trebuie sa fie incarcat/semnat/aprobat
                                                                * Pentru a trimite notificarea, documentul trebuie sa fie inapoi la intocmitor
                                                        -->
														<button *ngIf="
															row.file_signed_final == null &&
															row.file_signed !== null &&
															row.validare_user_type == 0 &&
															cerere.id_user_assigned == user.id_user &&
															!allFilesSigned(row.signatures)
														" type="button" class="btn btn-sm btn-success" title="Trimite document înapoi pe Flux" (click)="
															sendDocumentForwardIntocmitor(row.id_document)
														">
															<i class="fa-solid fa-play"></i> &nbsp; Trimite
															document înapoi pe Flux
														</button>

														<!--
                                                            Story: Reset semnatari Document - rSync cu Semnaturile de pe Flux - template document generat
                                                            Rules:
                                                                * Documentul nu trebuie sa fie semnat/aprobat de nimeni de pe flux
                                                                * Operatiune valabila doar de catre admini
                                                        -->
														<button *ngIf="
															row.file_signed == null &&
															user.user_type == 'admin'
														" type="button" class="btn btn-primary" title="Reset Semnatari - Document" (click)="
															rsyncSignaturesDocumentGenerat(row.id_document)
														">
															<i class="fa-solid fa-wrench"></i> &nbsp; Reset
															Semnatari - Document
														</button>

														<!--
                                                            Story: Trimitere document oficial/anexe via notificare catre cetatean via Email/Portal
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul oficial final trebuie sa fie incarcat!!! Obligatoriu
                                                                * Si obligatoriu sa aibe numar alocat
                                                                * Si sa nu fie confirmata trimiterea catre cetatean de documente via notificare

                                                        -->
														<button type="button" class="btn btn-sm btn-info" (click)="
															notificareCetateanDocumentOficial(
															row.id_document
															)
														" *ngIf="
															row.file_signed_final !== null &&
															cerere.id_user_assigned == user.id_user &&
															row.confirmat == null &&
															(row.numar !== null || row.registru_necesar == false)
														">
															<i class="fa-regular fa-envelope"></i> &nbsp;
															Trimite Document(e) oficial(e) Cetățean
														</button>

														<!--
                                                            Story: Resetare notificare trimitere cetatean
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul trebuie sa fie semnat si incarcat initial de intocmitor
                                                                * Documentul trebuie sa fie semnat/aprobat de nimeni de pe flux.. altfel nu  avem voie sa avem afisat acest buton
                                                                * Documentul oficial final trebuie sa fie incarcat!!! Obligatoriu
                                                                * Trebuie sa avem confirmare oficiala
                                                        -->
														<button type="button" class="btn btn-sm btn-danger" (click)="
															resetDocumentOficialNotificareCetatean(
															row.id_document
															)
														" *ngIf="
															row.file_signed !== null &&
															row.file_signed_final !== null &&
															row.validare_user_type == 0 &&
															cerere.id_user_assigned == user.id_user &&
															row.confirmat !== null
                              							">
															<i class="fa-solid fa-arrows-rotate"></i>
															&nbsp;Reset Notificare
														</button>


														<!--
                                                            Story: Switch Default Demplate Document Type - signatures - Manual
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Documentul oficial final trebuie sa fie incarcat!!! Obligatoriu
																* Neaparat la intocmitor, altfel nu se face acest aspect!!!
                                                        -->
														<button type="button" class="btn btn-sm btn-danger" (click)="setDocTypeForDocument(row.id_document)" 
															*ngIf="
																row.file_signed_final == null &&
																row.file_signed == null && 
																cerere.id_user_assigned == user.id_user &&
																row.validare_user_type == 0
															">
															<i class="fa-solid fa-wrench"></i>
															&nbsp;Switch Tip Draft - Document
														</button>
													</td>
												</tr>
												<tr class="d-flex justify-content-center align-items-start">
													<td width="20%"
														class="d-flex flex-column justify-content-start align-items-start no-borders">
														<p><strong>Număr: </strong> {{ row.numar || 'n/a' }}</p>
														<p><strong>Data: </strong> {{ row.data | date }}</p>
														<!--
                                                            Story: Actualizare valabilitate Document incarcat in registru
                                                            Rules:
                                                                * Operatorul trebuie sa fie asignat pe cerere obligatoriu
                                                                * Si obligatoriu sa aibe numar alocat
                                                        -->
														<p>
															<strong>Valabilitate: </strong>
															{{ row.valability || 'n/a' }}
															<span *ngIf="
															row.valability !== null &&
															cerere.id_user_assigned == user.id_user &&
															row.numar !== null
															">
																<button type="button" class="action-btn orange-text"
																	description="Editează" (click)="
                                    								editDateDocGenerabil(row.id_document)
                                  								">
																	<i class="fa-solid fa-pencil"></i>
																</button>
															</span>
														</p>
														<p><strong>Format Document:</strong><br/> {{row.doc_type_op}}</p>
													</td>
													<td width="80%"
														class="d-flex flex-column justify-content-start align-items-start no-borders">
														<p>
															<strong>Status: </strong>
															<span *ngIf="row.validare_status == 0">Nou</span>
															<span *ngIf="row.validare_status == 1">În așteptare
																semnături
															</span>
															<span *ngIf="row.validare_status == 2">Aprobată</span>
															<span *ngIf="row.validare_status == 3">Anulată</span>
															<span *ngIf="row.validare_status == 4">Invalidată</span>
														</p>
														<p *ngIf="
															row.validare_user_type == 0 &&
															row.file_signed_final == null
														">
															Întocmitor
															<span class="red-text">
																&nbsp;
																<i class="fa-solid fa-file-signature"></i>
															</span>
														</p>
														<!-- Afisarea de documente - anexe incarcate pe incarcare document oficial -->
														<div class="d-flex flex-column justify-content-start align-items-start"
															*ngIf="
																row.documenteOficialeAnexe &&
																row.documenteOficialeAnexe.length > 0
															">
															<p>
																<strong>Anexe Încărcate</strong>
															</p>
															<div
																class="documents-uploaded d-flex flex-row justify-content-center align-items-center">
																<span *ngFor="let doc of row.documenteOficialeAnexe">
																	<button class="btn btn-light m-2"
																		style="border: 1px solid #003399" type="button"
																		(click)="downloadAnexa(doc)">
																		{{ doc.old_name }}
																	</button>
																</span>
															</div>
														</div>
													</td>
												</tr>
											</ng-container>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="g-0">
				<div class="col">
					<div class="box-wrapper box-mesagerie mb-3">
						<div class="box-content-header">
							<div class="row p-1">
								<div class="col d-flex">
									<mat-card-title>
										<i class="fa-brands fa-rocketchat"></i>
										<span>Mesagerie</span>
									</mat-card-title>
                                    <div class="ms-2">
                                        <button *ngIf="cerere?.allow_messages" class="btn btn-success" (click)="allowMessages()" [disabled]="isLoading">Permite comunicare cetățean</button>
                                        <button *ngIf="!cerere?.allow_messages" class="btn btn-danger" (click)="allowMessages()" [disabled]="isLoading">NU permite comunicare cetățean</button>
                                    </div>
								</div>
								<div class="col d-flex justify-content-end">
									<div>
										<mat-button-toggle-group name="fontStyle" aria-label="Font Style"
											(change)="onMessagingChange($event)" value="internalMsg">
											<mat-button-toggle value="toCetatean">Către Cetățean</mat-button-toggle>
											<mat-button-toggle value="internalMsg">Mesaj Intern</mat-button-toggle>
											<mat-button-toggle value="nota">Notă</mat-button-toggle>
										</mat-button-toggle-group>
									</div>
								</div>
							</div>
						</div>
						<div class="box-content-body">
							<div class="row p-2" *ngIf="selectedMessagingToggle !== 'toCetatean'">
								<div class="col">
									<div class="fw-bold">Adăugați un nou mesaj</div>
								</div>
							</div>
							<div class="row p-2" *ngIf="selectedMessagingToggle == 'toCetatean'">
								<div class="col">
									<div class="fw-bold">Transmiteți către cetățean un mesaj</div>
								</div>
							</div>

							<form [formGroup]="sendMessageCetateanForm" (ngSubmit)="submitMessage('cetatean')"
								*ngIf="selectedMessagingToggle == 'toCetatean'">
								<div class="row">
									<div class="col">
										<angular-editor formControlName="message"
											[config]="editorConfig"></angular-editor>
										<mat-error *ngIf="
                        sendMessageCetateanForm.get('message').touched &&
                        sendMessageCetateanForm.get('message').invalid
                      ">
											Câmp obligatoriu
										</mat-error>
									</div>
								</div>

								<div class="solicitare-card__upload mx-2 mt-3">
									<div class="solicitare-card__upload-header">
										<p class="upload-text">Fotografii/Documente</p>
										<button class="upload-btn" (click)="fileInputCetatean.click()" type="button">
											<mat-icon class="upload-icon">cloud_upload</mat-icon>
											ÎNCARCĂ
										</button>
									</div>
									<div class="solicitare-card__upload-files" *ngIf="
                      sendMessageCetateanForm.value.files.length > 0 &&
                      !uploading.file
                    ">
										<div class="solicitare-card__upload-file" *ngFor="
                        let uploadedFile of sendMessageCetateanForm.value.files;
                        let i = index
                      ">
											<span class="solicitare-card__upload-file-name">
												{{
												uploadedFile.original_name.length > 30
												? (uploadedFile.original_name | slice : 0 : 30) +
												".."
												: uploadedFile.original_name
												}}
											</span>
											<div>
												<button class="solicitare-card__upload-file-delete" type="button"
													matTooltip="Șterge fișierul încărcat"
													(click)="removeFileCetatean(i)">
													<img class="btn-img" src="/assets/icons/delete.svg" alt="" />
												</button>
											</div>
										</div>
									</div>
									<mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
										*ngIf="uploading.file"></mat-spinner>

									<input type="file"
										accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
										id="upload-file-input-0" #fileInputCetatean name="fileInputCetatean"
										(change)="addFileCetatean($event, 'file')" multiple style="display: none" />
								</div>

								<!-- <div class="row my-3">
									<div class="col d-flex align-items-center">
										<mat-checkbox style="margin-right: 30px" formControlName="notify"
											color="primary">Notificare răspuns
										</mat-checkbox>
										<form [formGroup]="notifyAnswer" style="width: 30%">
											<ng-container *ngIf="sendMessageCetateanForm.get('notify')?.value">
												<mat-form-field class="mt-3">
													<mat-label>Număr zile</mat-label>
													<mat-select formControlName="notify_date_expire">
														<mat-option *ngFor="let response of responseTimes"
															[value]="response.value">
															{{ response.key }}
														</mat-option>
													</mat-select>
													<mat-error *ngIf="
                              notifyAnswer.get('notify_date_expire').touched &&
                              notifyAnswer
                                .get('notify_date_expire')
                                .hasError('required')
                            ">
														Câmp obligatoriu
													</mat-error>
												</mat-form-field>
											</ng-container>
										</form>
									</div>
								</div> -->

								<div class="row mt-2">
									<div class="col d-flex justify-content-between">
										<div class="p-1">
											<button class="btn btn-light upload-btn" type="button"
												(click)="openSabloane()">
												<span class="upload__text">Șabloane</span>
											</button>
										</div>

										<div class="p-1">
											<button class="btn btn-light upload-btn mx-1" type="submit"
												[disabled]="sendMessageCetateanForm.invalid">
												<span class="upload__text">TRIMITE</span>
											</button>
										</div>
									</div>
								</div>
							</form>

							<form [formGroup]="sendMessageInternForm" (ngSubmit)="submitMessage('intern')"
								*ngIf="selectedMessagingToggle == 'internalMsg'">
								<div class="row">
									<div class="col">
										<angular-editor formControlName="message"
											[config]="editorConfig"></angular-editor>
										<mat-error *ngIf="
                        sendMessageInternForm.get('message').touched &&
                        sendMessageInternForm.get('message').invalid
                      ">
											Câmp obligatoriu
										</mat-error>
									</div>
								</div>

								<div class="row p-1">
									<div class="col">
										<mat-form-field class="w-100">
											<mat-label>Adaugă coleg</mat-label>
											<mat-chip-grid #chipGrid aria-label="Selectare colegi">
												<mat-chip-row *ngFor="let coleague of coleagues"
													(removed)="removeColeague(coleague)">
													{{ coleague.name }}
													<button matChipRemove [attr.aria-label]="'remove ' + coleague.name">
														<mat-icon>cancel</mat-icon>
													</button>
												</mat-chip-row>
											</mat-chip-grid>
											<input placeholder="Coleg nou..." #coleagueInput
												[formControl]="coleaguesCtrl" [matChipInputFor]="chipGrid"
												[matAutocomplete]="auto"
												[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
												(matChipInputTokenEnd)="addColeague($event)" />
											<mat-autocomplete #auto="matAutocomplete"
												(optionSelected)="selectedColeagues($event)">
												<mat-option *ngFor="let coleague of filteredColeagues | async"
													[value]="coleague">
													{{ coleague.name }}
												</mat-option>
											</mat-autocomplete>
										</mat-form-field>
									</div>
								</div>

								<div class="solicitare-card__upload mx-2">
									<div class="solicitare-card__upload-header">
										<p class="upload-text">Fotografii/Documente</p>
										<button class="upload-btn" (click)="fileInputIntern.click()" type="button">
											<mat-icon class="upload-icon">cloud_upload</mat-icon>
											ÎNCARCĂ
										</button>
									</div>
									<div class="solicitare-card__upload-files" *ngIf="
                      sendMessageInternForm.value.files &&
                      sendMessageInternForm.value.files.length > 0 &&
                      !uploading.file
                    ">
										<div class="solicitare-card__upload-file" *ngFor="
                        let uploadedFile of sendMessageInternForm.value.files;
                        let i = index
                      ">
											<span class="solicitare-card__upload-file-name">
												{{
												uploadedFile.original_name.length > 30
												? (uploadedFile.original_name | slice : 0 : 30) +
												".."
												: uploadedFile.original_name
												}}
											</span>
											<div>
												<button class="solicitare-card__upload-file-delete" type="button"
													matTooltip="Șterge fișierul încărcat" (click)="removeFileIntern(i)">
													<img class="btn-img" src="/assets/icons/delete.svg" alt="" />
												</button>
											</div>
										</div>
									</div>
									<mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
										*ngIf="uploading.file"></mat-spinner>

									<input type="file"
										accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
										id="upload-file-input-0" #fileInputIntern name="fileInputIntern"
										(change)="addFileIntern($event, 'file')" multiple style="display: none" />
								</div>

								<div class="col d-flex justify-content-end">
									<button class="btn btn-light upload-btn m-3" type="submit"
										[disabled]="sendMessageInternForm.invalid">
										<span class="upload__text">TRIMITE</span>
									</button>
								</div>
							</form>

							<form [formGroup]="sendMessageNotitaForm" (ngSubmit)="submitMessage('nota')"
								*ngIf="selectedMessagingToggle == 'nota'">
								<div class="row">
									<div class="col">
										<angular-editor formControlName="message"
											[config]="editorConfig"></angular-editor>
										<mat-error *ngIf="
                        sendMessageNotitaForm.get('message').touched &&
                        sendMessageNotitaForm.get('message').invalid
                      ">
											Câmp obligatoriu
										</mat-error>
									</div>
								</div>

								<div class="solicitare-card__upload mx-2 mt-3">
									<div class="solicitare-card__upload-header">
										<p class="upload-text">Fotografii/Documente</p>
										<button class="upload-btn" (click)="fileInputNotita.click()" type="button">
											<mat-icon class="upload-icon">cloud_upload</mat-icon>
											ÎNCARCĂ
										</button>
									</div>
									<div class="solicitare-card__upload-files" *ngIf="
                      sendMessageNotitaForm.value.files.length > 0 &&
                      !uploading.file
                    ">
										<div class="solicitare-card__upload-file" *ngFor="
                        let uploadedFile of sendMessageNotitaForm.value.files;
                        let i = index
                      ">
											<span class="solicitare-card__upload-file-name">
												{{
												uploadedFile.original_name.length > 30
												? (uploadedFile.original_name | slice : 0 : 30) +
												".."
												: uploadedFile.original_name
												}}
											</span>
											<div>
												<button class="solicitare-card__upload-file-delete" type="button"
													matTooltip="Șterge fișierul încărcat" (click)="removeFileNota(i)">
													<img class="btn-img" src="/assets/icons/delete.svg" alt="" />
												</button>
											</div>
										</div>
									</div>
									<mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
										*ngIf="uploading.file"></mat-spinner>

									<input type="file"
										accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
										id="upload-file-input-0" #fileInputNotita name="fileInputNotita"
										(change)="addFileNotita($event, 'file')" multiple style="display: none" />
								</div>

								<div class="col d-flex justify-content-end">
									<button class="btn btn-light upload-btn m-3" type="submit"
										[disabled]="sendMessageNotitaForm.invalid">
										<span class="upload__text">TRIMITE</span>
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			<app-cereri-istoric [user]="user" [istoric]="cerere?.istoric" [id_cerere]="cerere?.id_cerere"
				[notifyIds]="cerere?.historyNotify" (requestInfoUpdated)="getRequestInfo()" (isLoading)="onIsLoadingChange($event)"></app-cereri-istoric>
		</mat-card>
	</div>
	<div class="col-4">
		<div class="g-0">
			<div class="row">
				<div class="col">
					<div class="box-wrapper box-info">
						<div class="box-content-header">
							<div class="row p-1">
								<div class="col">
									<mat-card-title>
										<i class="fa-solid fa-circle-info"></i>
										<span>Info cerere</span>
									</mat-card-title>
								</div>
							</div>
						</div>
						<div class="box-content-body">
							<table class="table table-condensed table-wrapper-box">
								<tbody>
									<tr>
										<td width="40%" class="text-center">
											<strong>Tip</strong>
										</td>
										<td class="text-left">{{ cerere?.subject }}</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Categorie</strong>
										</td>
										<td class="text-left">{{ cerere?.categorie_directie }}</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Categorie Departament</strong>
										</td>
										<td class="text-left">
											{{ cerere?.categorie_compartiment || "n/a" }}
										</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Prioritate</strong>
										</td>
										<td class="text-left">
											<span class="badge" [ngStyle]="{
                          'background-color': cerere?.priority_bg_color,
                          color: cerere?.priority_color
                        }">
												{{ cerere?.priority_name }}
											</span>
										</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Status</strong>
										</td>
										<td class="text-left">
											<span class="badge" [ngStyle]="{
                          'background-color': cerere?.status_bg_color,
                          color: cerere?.status_color
                        }">
												{{ cerere?.status_name }}
											</span>
										</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Sla</strong>
										</td>
										<td class="text-left">
											<div [innerHTML]="safeHtml"></div>
										</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Instituție/Direcție</strong>
										</td>
										<td class="text-left">{{ cerere?.directie }}</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Serviciu/Birou</strong>
										</td>
										<td class="text-left">{{ cerere?.compartiment }}</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Cerere asignat</strong>
										</td>
										<td class="text-left">{{ cerere?.user_assigned }}</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Dată creat</strong>
										</td>
										<td class="text-left">
											{{ cerere?.created_at | date : "dd-MM-yyyy HH:mm" }}
										</td>
									</tr>
									<tr>
										<td width="40%" class="text-center">
											<strong>Dată actualizat</strong>
										</td>
										<td class="text-left">
											{{ cerere?.updated_at | date : "dd-MM-yyyy HH:mm" }}
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="box-wrapper box-actiuni-cerere">
					<div class="box-content-header">
						<div class="row p-1">
							<div class="col">
								<mat-card-title>
									<i class="fa-solid fa-shuffle"></i>
									<span>Operațiuni cerere</span>
								</mat-card-title>
							</div>
						</div>
					</div>
					<div class="box-content-body">
						<div class="row p-2 d-flex">
							<!--
                                Story: Preluare cerere
                                Clause: OR
                                Rules:
                                    * Sa nu fie asignat cineva pe cerere
                                    * Sa nu fiu asignat pe cerere

                                    ** De adaugat, permisiune pentru a putea prelua cererile...
                            -->
							<div class="w-auto" *ngIf="
								cerere?.id_user_assigned == null ||
								cerere?.id_user_assigned !== user.id_user
								">
								<button class="btn btn-light upload-btn" type="button"
									(click)="confirmPreluarePersonala()">
									<span class="upload__text">PRELUARE PERSONALĂ</span>
								</button>
							</div>

							<!--
                                Story: Preluare numar din cadrul registraturii - InDoc
                                Clause: AND
                                Rules:
                                    * Sa fie asignat pe cerere
                                    * Sa nu aibe numar alocat pe cerere
                                    * Sa aibe dreptul la permisiunea de preluare numar din InDoc
                            -->
							<div class="w-auto" *ngIf="showPreluareNumarRegistratura()">
								<button class="btn btn-light upload-btn" type="button"
									(click)="confirmPreluareNumarRegistratura()">
									<span class="upload__text">PRELUARE NUMĂR REGISTRATURA</span>
								</button>
							</div>
						</div>
						<div class="row p-2 d-flex">
							<div class="col" [class.hidden]="
                  cerere?.cancel_type == 1 && cerere?.cancel_date !== null
                ">
								<actiuni-cerere-card title="Status validat" description="Nevalidat" iconName="check"
									[cerere]="cerere" actionText="Validează" actionType="validate"
									(buttonClicked)="handleButtonClick($event)"
									(buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
							</div>
							<ng-container>
								<!-- *ngIf="cerere.cancel_type === null" -->
								<div class="col" *ngIf="
                    cerere?.validated_date === null &&
                    ((cerere?.cancel_type == null &&
                      cerere?.registratura?.finalize_date == null) ||
                      cerere?.cancel_type == 1)
                  ">
									<actiuni-cerere-card title="Invalidare Cerere"
										description="Cerere incă valabilă de validare. Nu invalidați decât dacă este cazul!"
										iconName="report_problem" actionText="Invalidează" [cerere]="cerere"
										actionType="invalidate" (buttonClicked)="handleButtonClick($event)"
										(buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
								</div>
								<div class="col" *ngIf="
                    (cerere?.validated_date !== null &&
                      cerere?.cancel_type == null &&
                      cerere?.registratura?.finalize_date == null) ||
                    cerere?.cancel_type == 2
                  ">
									<actiuni-cerere-card title="Clasare" description="Clasare" iconName="report_problem"
										actionText="Clasare" [cerere]="cerere" actionType="anulare"
										(buttonClicked)="handleButtonClick($event)"
										(buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
								</div>
							</ng-container>
							<ng-container *ngIf="
                  cerere?.cancel_date !== null ||
                  cerere?.validated_date !== null
                ">
								<div class="col">
									<actiuni-cerere-card title="Status Închidere Lucrare"
										description="Inchidere lucrare doar în momentul în care a fost soluționată cererea."
										iconName="check" actionText="Închidere lucrare" [cerere]="cerere"
										actionType="finalizare" (buttonClicked)="handleButtonClick($event)"
										(buttonResetClicked)="handleButtonResetClick($event)"></actiuni-cerere-card>
								</div>
							</ng-container>
							<ng-container>
								<div class="row m-0">
									<button type="button" class="btn w-100"
										[class.btn-light]="showSignatures !== doc.id_document"
										[class.btn-primary]="showSignatures == doc.id_document"
										*ngFor="let doc of cerere?.generabile"
										(click)="switchViewSignatures(doc)">
										Document ID: {{ doc.id_document }}
									</button>
									<table class="table table-condensed custom-table my-table-condensed" *ngFor="let doc of cerere?.generabile; let i = index"
									[class.hidden]="showSignatures !== doc.id_document">
										<thead>
											<tr>
												<td colspan="3">
													<div class="col">
														<div class="row">
															<div class="col">
																<p><strong>Template/Document:</strong> {{doc.template}}</p>
																<p><strong>Format:</strong> {{doc.doc_type_op}}</p>
																<p *ngIf="doc.doc_type == 2"><strong>Document Flux activ - Semnare:</strong> {{doc.doc_type_active_op}}</p>
															</div>
														</div>
														<div class="row">
															<div class="col">
																<mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onDestinatieChange($event, doc)"
																	[(ngModel)]="destination_signatures_document" *ngIf="doc.doc_type == 2">
																	<mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
																	<mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
																</mat-button-toggle-group>
															</div>
															<div class="col">
																<div class="d-flex justify-content-end">
																	<button *ngIf="showEditSemnatari == false"
																		(click)="editSemnatari($event, doc)" type="button"
																		class="btn btn-danger"
																		style="margin-right: 10px; height: fit-content">
																		Actualizează Semnatari
																	</button>
																	<!-- <br /> -->
																	<button style="height: fit-content" *ngIf="showEditSemnatari"
																		(click)="addSemnatari(doc)" type="button"
																		class="btn btn-warning">
																		Adaugă Semnatari
																	</button>
																</div>
															</div>
														</div>
													</div>
												</td>
											</tr>
											<tr>
												<th>Departament/Funcție</th>
												<th>Operator</th>
												<th class="text-center">Operațiuni</th>
											</tr>
										</thead>

										<tbody>
											<!-- <tr>
												<td colspan="3">
													
												</td>
											</tr> -->
											<!-- we need this kind of selection of signatures strictly to show the necessary selection of document signed -->
											<tr *ngIf="doc.signatures_doc[documentTypesTranslation[destination_signatures_document]].length == 0">
												<td colspan="3" class="text-center"><i><strong>Lipsă Semnatari.</strong></i></td>
											</tr>
											<tr *ngFor="let signature of doc.signatures_doc[documentTypesTranslation[destination_signatures_document]]">
												<td>
													{{ signature.user_type_name }}
													<span *ngIf="
													doc.validare_user_type == signature.user_type && signature.doc_type == doc.doc_type_active
													" class="red-text">
														&nbsp;
														<i class="fa-solid fa-file-signature"></i>
													</span>
												</td>
												<td class="text-center">
													{{ signature.user_name || "n/a" }}
												</td>
												<td>
													<span *ngIf="signature.type == 1" class="badge badge-success m-2">
														<i class="fa-solid fa-check"></i>
														&nbsp;Aprobat</span>
													<span *ngIf="signature.type == 2" class="badge badge-danger m-2">
														<i class="fa-solid fa-times"></i>
														&nbsp;Anulat</span>

													<span *ngIf="signature.action_date !== null" class="m-2">
														<i class="fa-regular fa-calendar-check"></i>
														{{ signature.action_date }}
														<br />
													</span>
													<span *ngIf="signature.type == 2">
														<span class="fa fa-comments-o"></span>
														{{ signature.observations || "n/a" }}
													</span>
													<!--
                                                        Story: Descarcare document semnat de catre semnatar
                                                        Rules:
                                                            * Sa fie documentul semnat si incarcat in cadrul platformei

                                                        Params:
                                                            * signature.id - id-ul semnaturii
                                                    -->
													<button type="button" class="btn btn-sm btn-primary m-2" (click)="
													downloadDocumentFromSignatureSigned(signature.id)
													" *ngIf="signature.type == 1">
														<img src="assets/icons/icon-download.svg" alt="Descarcă" />
														&nbsp;Descarcă
													</button>

													<!--
                                                        Story: Resetare - incarcare document semnat de catre operator
                                                        Rules:
                                                            * Sa fie la rand de semnat pe document obligatoriu
                                                            * Sa aibe functia din dreptul semnatarului
                                                            * Sa fie incarcat documentul semnat de catre semnatar

                                                        Params:
                                                            * signature.id - id-ul semnaturii
                                                    -->
													<button type="button" class="btn btn-sm btn-info m-2"
														(click)="resetDocument(signature.id)" *ngIf="
															signature.file_signed !== null &&
															user.functie_id == signature.user_type &&
															doc.file_signed_final == null
                            							">
														<!--  *ngIf="doc.canReset" -->
														<i class="fa-solid fa-arrows-rotate"></i>
														&nbsp;Reset
													</button>

													<!--
                                                        Story: Trimitere document in continuare pe flux
                                                        Rules:
                                                            * Sa fie la rand de semnat pe document obligatoriu
                                                            * Sa aibe functia din dreptul semnatarului
                                                            * Sa fie incarcat documentul semnat de catre semnatar
                                                            * Sa nu fie documentul oficial incarcat!!

                                                        Params:
                                                            * signature.id - id-ul semnaturii
                                                    -->
													<button *ngIf="
													signature.file_signed !== null &&
													doc.validare_user_type == user.functie_id &&
													signature.user_type == user.functie_id &&
													doc.file_signed_final == null && 
													doc.doc_type_active == signature.doc_type
													" type="button" class="btn btn-sm btn-light" title="Trimite document în continuare pe Flux"
														(click)="sendDocumentForwardToSigner(signature.id)" style="background-color: #e9c1e5;">
														<i class="fa-solid fa-play"></i> &nbsp; Trimite
														document în continuare pe Flux
													</button>

													<!--
                                                        Story: Zona de butoane active, doar daca se afla in stadiu la semnare la operator
                                                        Rules:
                                                            * Sa fie la rand de semnat pe document obligatoriu
                                                            * Sa nu fie vreun semnatar pe semnatura propriu-zisa
                                                            * Sa nu fie incarcat documentul semnat de catre operator
                                                            * Sa nu fie incarcat documentul oficial final
                                                    -->
													<div class="row">
														<div class="col" *ngIf="
															cerere?.validare_status !== 3 &&
															signature.user_id == null &&
															signature.file_signed == null
														">
															<!--
                                                                Story: Aprobare prin incarcarea de document oficial semnat / confirmare tabel
                                                                Rules:
                                                                    * Sa fie la rand de semnat pe document obligatoriu
                                                                    * Sa nu fie vreun semnatar pe semnatura propriu-zisa
                                                                    * Sa nu fie incarcat documentul semnat de catre operator
                                                                    * Sa nu fie incarcat documentul oficial final

                                                                Params:
                                                                    * signature.id - id-ul semnaturii
                                                            -->
															<button type="button" class="btn btn-sm btn-success m-2"
																(click)="validateDocument(doc.id_document, 2)" *ngIf="
																signature.type == 0 &&
																signature.doc_type == doc.doc_type_active &&
																user.functie_id == signature.user_type &&
																user.functie_id == doc.validare_user_type &&
																doc.validare_user_type > 0 &&
																signature.file_signed == null
																">
																<i class="fa-solid fa-check"></i> &nbsp; Aprobă
															</button>

															<!--
                                                                Story: Refux document de semnat de catre operator
                                                                Rules:
                                                                    * Sa fie la rand de semnat pe document obligatoriu
                                                                    * Sa nu fie vreun semnatar pe semnatura propriu-zisa
                                                                    * Sa nu fie incarcat documentul semnat de catre operator
                                                                    * Sa nu fie incarcat documentul oficial final

                                                                Params:
                                                                    * signature.id - id-ul semnaturii
                                                            -->
															<!-- <button type="button" class="btn btn-sm btn-danger m-2"
                                                                (click)="anulareCerereSuperior(signature.id)" *ngIf="signature.type == 0 &&
																user.functie_id == signature.user_type &&
																user.functie_id == doc.validare_user_type &&
																doc.file_signed !== null && doc.file_signed_final == null">
                                                                <i class="fa-solid fa-times"></i> &nbsp; Refuză
                                                            </button> -->

															<!--
                                                                Story: In asteptare aprobare document de catre semnatar
                                                                Clause: OR
                                                                Rules:
                                                                    * Sa nu fie la rand cu semnarea de document
                                                                    * Sa nu fie vreun semnatar pe semnatura propriu-zisa
                                                                    * Sa nu fie incarcat documentul semnat de catre operator
                                                            -->
															<button type="button" class="btn btn-sm btn-warning"
																disabled *ngIf="
																signature.type !== 0 ||
																user.functie_id !== doc.validare_user_type ||
																user.functie_id !== signature.user_type ||
																signature.doc_type !== doc.doc_type_active ||
																doc.file_signed == null
																">
																<i class="fa-solid fa-hourglass-start"></i>
																&nbsp;În așteptare aprobare
															</button>
															<!--
                                                                Story: Trimite document - Întocmitor
                                                                Rules:
                                                                    * Sa fie la rand de semnat pe document obligatoriu
                                                                    * Sa nu fie vreun semnatar pe semnatura propriu-zisa (Necesita reset gen)
                                                                    * Sa nu fie incarcat documentul semnat de catre operator
                                                                    * Sa nu fie incarcat documentul oficial final

                                                                Params:
                                                                    * signature.id - id-ul semnaturii
                                                            -->

															<button *ngIf="
																signature.file_signed == null &&
																doc.validare_user_type == user.functie_id &&
																signature.user_type == user.functie_id &&
																signature.doc_type == doc.doc_type_active &&
																doc.file_signed_final == null
																" type="button" class="btn btn-sm btn-light" title="Trimite document - Întocmitor"
																(click)="sendDocumentToIntocmitor(signature.id)" style="background-color: #e9c1e5;">
																<i class="fa-solid fa-backward"></i> &nbsp;
																Trimite document - Întocmitor
															</button>
														</div>
													</div>
												</td>
											</tr>
											<tr *ngIf="showEditSemnatari == true">
												<td colspan="3">
													<div class="col">
														<div class="row" *ngIf="doc.signatures_doc[documentTypesTranslation[destination_signatures_document]].length > 0">
															<div class="col">
																<p class="text-left"><strong>Actualizare Semnatar Curent
																		Document</strong></p>
															</div>
														</div>
														<div class="row" *ngIf="doc.signatures_doc[documentTypesTranslation[destination_signatures_document]].length > 0">
															<div class="col">
																<mat-form-field appearance="fill">
																	<mat-label>Selectați un semnatar</mat-label>
																	<mat-select [(ngModel)]="selectedSignature"
																		(selectionChange)="onSignatureSelect()">
																		<mat-option
																			*ngFor="let signature of selectSemnatariList"
																			[value]="signature.user_type">
																			{{ signature.user_type_name }}
																		</mat-option>
																	</mat-select>
																</mat-form-field>
															</div>
														</div>
														<div class="row">
															<div class="col">
																<div class="d-flex justify-content-between">
																	<button type="button" class="btn btn-warning"
																		(click)="editSemnatari($event)">Inchide
																	</button>
																	<button 
																		*ngIf="doc.signatures_doc[documentTypesTranslation[destination_signatures_document]].length > 0"
																		(click)="editSemnatariSubmit(doc.id_document)" type="button" class="btn btn-success" style="margin-left: 10px; height: fit-content">
																		Actualizează
																	</button>
																</div>
															</div>
														</div>
													</div>

												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="p-1">
			<mat-divider></mat-divider>
		</div>
		<div class="row">
			<app-actualizare-cerere [data]="data" (cerereChanged)="onCerereChanged($event)"></app-actualizare-cerere>
		</div>
	</div>
</div>
<div class="section-spinner position-fixed" *ngIf="isLoading">
	<div class="spinner position-absolute top-50 start-50 translate-middle">
		<img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
		<mat-spinner></mat-spinner>
		<h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
	</div>
</div>